import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'home',
			meta: {
				title: '首页'
			},
			component: Home
		},
		{
			path: '/bind_taobao',
			name: 'bind_taobao',
			meta: {
				title: '帐号授权'
			},
			component: () => import( /* webpackChunkName: "bind_taobao" */ './views/dialog/bind_taobao.vue')
		},
		{
			path: '/help',
			name: 'help',
			component: () => import( /* webpackChunkName: "help" */ './views/layouts/layout.vue'),
			children: [{
					path: 'bindalipay',
					meta: {
						title: '支付宝绑定教程'
					},
					component: () => import( /* webpackChunkName: "help" */ './views/help/bindalipay')
				},
				{
					path: 'webview',
					meta: {
						title: '帐号授权'
					},
					component: () => import( /* webpackChunkName: "help" */ './views/help/bindalipay')
				},
				{
					path: 'answer',
					meta: {
						title: '常见问题'
					},
					component: () => import( /* webpackChunkName: "help" */ './views/help/answer')
				}
			]

		},
		{
			path: '/webview',
			name: 'webview',
			meta: {
				title: '帐号授权'
			},
			component: () => import( /* webpackChunkName: "webview" */ './views/dialog/webview')
		},
		{
			path: '/module',
			name: 'html5Modules',
			component: () => import( /* webpackChunkName: "html5Modules" */ './views/layouts/layout.vue'),
			children: [
				{
					path: 'html5Modules',
					meta: {
						title: '专题活动'
					},
					component: () => import( /* webpackChunkName: "html5Modules" */ './views/html5/html5Modules')
				},
				{
					path: 'liangfantuan',
					meta: {
						title: '量贩团 - 多买多省'
					},
					component: () => import( /* webpackChunkName: "html5Modules" */ './views/html5/liangfantuan')
				},
				{
					path: 'activityLink',
					meta: {
						title: '最新活动列表'
					},
					component: () => import( /* webpackChunkName: "html5Modules" */ './views/html5/activityLink')
				},
				{
					path:"discount-radar",
					meta: {
						title: '优惠雷达'
					},
					component: () => import( /* webpackChunkName: "html5Modules" */ './views/html5/discount-radar')
				},
				{
					path:"take-out-food",
					meta: {
						title: '外卖返现'
					},
					component: () => import( /* webpackChunkName: "html5Modules" */ './views/html5/take-out-food')
				}
			]

		},
		{
			path: '/html5',
			name: 'html5Api',
			component: () => import( /* webpackChunkName: "html5Api" */ './views/layouts/html5_layout.vue'),
			children: [
				{
					path: 'fpgl',
					meta: {
						title: '翻牌攻略 - 猫超',
						isApp: false
					},
					component: () => import( /* webpackChunkName: "html5Api" */ './views/html5Api/maochao/fpgl')
				},
				{
					path: 'xsbjgl',
					meta: {
						title: '限时变价攻略 - 猫超',
						isApp: false
					},
					component: () => import( /* webpackChunkName: "html5Api" */ './views/html5Api/maochao/xsbjgl')
				},
				{
					path: 'sytyggl',
					meta: {
						title: '体验馆攻略 - 猫超',
						isApp: false
					},
					component: () => import( /* webpackChunkName: "html5Api" */ './views/html5Api/maochao/sytyggl')
				},
				{
					path: 'agreement',
					meta: {
						title: '用户协议',
						isApp: false
					},
					component: () => import( /* webpackChunkName: "html5Api" */ './views/html5Api/agreement/agreement')
				},
				{
					path: 'privacy',
					meta: {
						title: '隐私政策',
						isApp: false
					},
					component: () => import( /* webpackChunkName: "html5Api" */ './views/html5Api/agreement/privacy')
				}
			]

		},
		{
			path: '/h5Detail',
			name: 'h5Detail',
			component: () => import( /* webpackChunkName: "h5Detail" */ './views/layouts/layout.vue'),
			children: [{
					path: 'tb',
					meta: {
						title: '热卖'
					},
					component: () => import( /* webpackChunkName: "h5Detail" */ './views/h5Detail/tb')
				},
				{
					path: 'jd',
					meta: {
						title: '热卖'
					},
					component: () => import( /* webpackChunkName: "h5Detail" */ './views/h5Detail/jd')
				},
				{
					path: 'pdd',
					meta: {
						title: '热卖'
					},
					component: () => import( /* webpackChunkName: "h5Detail" */ './views/h5Detail/pdd')
				},
				{
					path: 'dapei',
					meta: {
						title: '穿衣搭配'
					},
					component: () => import( /* webpackChunkName: "h5Detail" */ './views/h5Detail/dapei')
				},
				{
					path: 'daren',
					meta: {
						title: '达人文章'
					},
					component: () => import( /* webpackChunkName: "h5Detail" */ './views/h5Detail/daren')
				}
			]

		},
	]
})
